import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import type { AppMenu } from '@modules/sidebar/utils';
import { AppModule } from '@modules/core/plugins/AppModule';
import {
  GROUPS_OF_ADMINS_LIST_ROUTE_NAME,
  GROUPS_OF_ADMINS_MAIN_ROUTE_NAME,
  GROUPS_OF_ADMINS_PERMISSIONS,
  TRANSLATION_GROUPS_OF_ADMINS_LIST,
} from '@modules/groups-of-admins/constants';
import { GroupsOfAdminsCreateModule } from '@modules/groups-of-admins/submodules/create/GroupsOfAdminsCreateModule';
import {
  GroupsOfAdminsEditModule,
} from '@modules/groups-of-admins/submodules/edit/GroupsOfAdminsEditModule';
import { getTranslationKeys } from '@modules/groups-of-admins/translations';
import { useI18n } from '@modules/i18n/composables';
import {
  ADMIN_PERSONNEL_MENU_ITEM,
  TRANSLATION_GROUP_SIDEBAR,
} from '@modules/sidebar/constants';

export class GroupsOfAdminsModule extends AppModule {
  protected submodules = [
    new GroupsOfAdminsCreateModule(),
    new GroupsOfAdminsEditModule(),
  ];

  addRoutes(router: AppVueRouter): void {
    router.addAdminRoute({
      name: GROUPS_OF_ADMINS_MAIN_ROUTE_NAME,
      path: 'groups',
      permission: GROUPS_OF_ADMINS_PERMISSIONS.SHOW,
      component: () => import('@modules/core/components/SimpleChildRoutePage/SimpleChildRoutePage.vue'),
      keepAliveInclude: 'GroupsOfAdminsListPage',
    });

    router.addChildRoute(GROUPS_OF_ADMINS_MAIN_ROUTE_NAME, {
      name: GROUPS_OF_ADMINS_LIST_ROUTE_NAME,
      path: '',
      permission: GROUPS_OF_ADMINS_PERMISSIONS.SHOW,
      component: () => import('@modules/groups-of-admins/pages/GroupsOfAdminsListPage/GroupsOfAdminsListPage.vue'),
    });
  }

  addMenu(menu: AppMenu): void {
    const { getTPath } = useI18n();

    menu.addChildAdminMenuItem(ADMIN_PERSONNEL_MENU_ITEM, {
      caption: getTPath(TRANSLATION_GROUP_SIDEBAR, 'PERSONNEL_GROUPS_LIST'),
      to: {
        name: GROUPS_OF_ADMINS_LIST_ROUTE_NAME,
      },
      permission: GROUPS_OF_ADMINS_PERMISSIONS.SHOW,
      id: GROUPS_OF_ADMINS_LIST_ROUTE_NAME,
      order: 20,
    });
  }

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUPS_OF_ADMINS_LIST, getTranslationKeys);
  }
}
